import { Flex } from '@qga/roo-ui/components';

import type { PackageOption as PackageOptionType } from '@shared/v2/utils/getPackageOptions';

import useProcuredOffer from '@/components/PackagePage/hooks/useProcuredOffer';
import usePropertyContent from '@/hooks/usePropertyContent';
import OtherOption from '@/v2/components/pages/PackageViewV2/components/OtherOption';
import { UI } from '@/v2/types';
import CampaignInfo from '../../../../../CampaignInfo';
import RoomOptionDetails from '../../../../../RoomOptionDetails';

interface SelectedRoomPanelProps {
  upgradeOffer?: UI.RoomOptionOffer;
  selectedPackageOption?: PackageOptionType;
  selectedRoomOption: UI.RoomOption;
}

const SelectedRoomPanel = ({
  upgradeOffer,
  selectedPackageOption,
  selectedRoomOption,
}: SelectedRoomPanelProps) => {
  const propertyContent: UI.Property = usePropertyContent();
  const procuredOffer: UI.ProcuredOffer | undefined = useProcuredOffer();

  const { matchingOffer } = selectedRoomOption;

  return (
    <Flex flexDirection="column" gap="24px">
      <CampaignInfo />
      {matchingOffer && (
        <RoomOptionDetails
          packageName={selectedPackageOption?.title}
          offer={matchingOffer}
          roomType={selectedRoomOption.roomType}
          limitInclusions
        />
      )}
      <OtherOption
        upgradeOffer={upgradeOffer}
        selectedRoomOption={selectedRoomOption}
        propertyContent={propertyContent}
        procuredOffer={procuredOffer}
      />
    </Flex>
  );
};

export default SelectedRoomPanel;
